import React, { useState, useEffect } from 'react';
import { resetUrl, getUrl } from '../../../../common/reset-image';
import './index.less';
import DetailIcon from '../../../../common/detail-icon';
import SkuStore from '@/stores/sku';
import { useFavorite } from '@/hooks/useFavorite';

interface PropTypes {
  activeId: number;
  mediaItems: Partial<DetailTypes.MediaItem>[];
  productId: number;
  setActiveId: React.Dispatch<React.SetStateAction<number>>;
}

export default function MainImage(props: PropTypes) {
  const { activeId, mediaItems, productId, setActiveId } = props;
  const { isFavorite, handleFavorite } = useFavorite(productId);

  const [mainImgSrc, setMainImgSrc] = useState<string>();
  const skuInfo = SkuStore((state) => state.product);

  const originImage = skuInfo?.skuImageReview?.originImage;
  const currentItem = mediaItems[activeId];

  useEffect(() => {
    if (!originImage) return;
    setMainImgSrc(resetUrl(originImage, '720', 'q50'));
  }, [originImage]);

  useEffect(() => {
    if (activeId === -1) return;
    setMainImgSrc(resetUrl(getUrl(currentItem), '720', 'q50'));
  }, [currentItem]);

  if (!mainImgSrc) return null;

  return (
    <>
      <div className="quick-view-image-view">
        <img src={mainImgSrc} alt="product image" />
      </div>

      <div className="detail-favorite" onClick={handleFavorite}>
        {isFavorite ? (
          <DetailIcon
            className="detail-icon-favorite-fill"
            symbol="icon-follow-fill"
            width="22"
            height="22"
          />
        ) : (
          <DetailIcon
            className="detail-icon-favorite"
            symbol="icon-follow"
            width="22"
            height="22"
          />
        )}
      </div>
    </>
  );
}
